/*import { I18n, Translate, Localize } from "react-i18nify";
import { config } from "@src/config";

// csv => https://docs.google.com/spreadsheets/d/1Miq3qcnNzkbkQ7BR4-idnuuEQabT90vonc7276Wu2UA/edit#gid=0

const initI18n = (trans) => {
    I18n.setTranslations(trans, true);
    I18n.setLocale(config.lang, true);
};

var currentLang = config.lang;
const changeLang = (lang) => {
    I18n.setLocale(lang, true);
    currentLang = lang;
};

export {
    initI18n,
    changeLang,
    currentLang,
    I18n,
    Translate,
}*/


const _ = (key, ns = "", args: any = null) => {
    const translations = (window['i18n']);
    var str = (translations[ns] && translations[ns][key]) ? translations[ns][key] : key;
    if (args) {
        Object.keys(args).forEach( k => {
            const v = args[k];
            str = str.replace(`{${k}}`, v);
        } );
    }
    return str;
}

export {
    _
}


// WEBPACK FOOTER //
// ./src/services/i18n.ts